import { Component, Input } from '@angular/core';
import { fadeInOut } from '@shared/animations';

@Component({
  selector: 'sp-page-content-container',
  template: `
    <div [ngClass]="{ 'full-width': isFullWidth, 'app-container': isAppContainer }" [@fadeInOut]>
      <sp-page-title *ngIf="!isAppContainer" class="page-title" [title]="title"></sp-page-title>
      <ng-content></ng-content>
    </div>
  `,
  styleUrls: ['./page-content-container.component.scss'],
  animations: [fadeInOut],
})
export class PageContentContainerComponent {
  @Input() isFullWidth = true;
  @Input() isAppContainer = false;
  @Input() title: string;
}
